import {Component, OnInit, ViewChild} from '@angular/core';
import {TabsetComponent} from 'ngx-bootstrap';
import {PageService} from 'src/app/shared/layout/services/page.service';

@Component({
    selector: 'app-historico-tab',
    templateUrl: './historico-tab.component.html',
    styleUrls: ['./historico-tab.component.scss']
})
export class HistoricoTabComponent implements OnInit {

    @ViewChild('tabsetComponent', {static: false}) tabSetComponent: TabsetComponent;

    constructor(private page: PageService) {
    }

    ngOnInit() {
        this.page.defineTitle('HISTORICO');
    }

}
